<template>
	<div class="flex h-full">
		<NavigationMenu
			class="hidden h-full lg:block"
			viewport-class="left-[-100px] bg-primary"
		>
			<NavigationMenuList class="h-full" orientation="horizontal">
				<NavigationMenuItem class="h-full">
					<NavigationMenuTrigger
						v-model:mouse-over="navigationStore.isProfileNavigationMenuOpen"
						:is-nav-option-open="
							navigationStore.isProfileNavigationMenuOpen ? true : undefined
						"
						class="h-full"
					>
						<PortalHeaderNavProfileOption
							v-bind="props"
							:bg-variant="bgVariant === 'primary' ? 'primary' : 'translucide'"
						/>
					</NavigationMenuTrigger>
					<NavigationMenuContent
						v-model:mouse-over="navigationStore.isProfileNavigationMenuOpen"
						class="h-full"
					>
						<ul class="grid min-h-[123px] px-6 py-8 lg:w-[326px]">
							<li class="border-b border-primary-light-4 pb-2">
								<PortalHeaderNavMobileOptionLink
									v-if="profileOptions?.[0]"
									:option="profileOptions[0]"
									class="flex items-center px-3 py-4 hover:bg-primary-light-4"
								/>
							</li>
							<li class="pt-2">
								<PortalHeaderNavLogoutButton
									class="size-full px-3 py-4 hover:bg-primary-light-4"
									@logout="handleLogout"
								/>
							</li>
						</ul>
					</NavigationMenuContent>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>

		<PortalHeaderNavProfileOption
			v-bind="props"
			class="lg:hidden"
			@click="$emit('open-profile-menu')"
		/>
	</div>
</template>
<script setup lang="ts">
import { useNavigationStore } from '~/store/navigationStore';
import {
	profileOptions,
	type PortalHeaderNavLoggedInfosEmailVariantProps,
	type BackgroundVariantProps
} from '.';

const { clear } = useUserSession();
const navigationStore = useNavigationStore();

const props = defineProps<{
	variant: PortalHeaderNavLoggedInfosEmailVariantProps['variant'];
	bgVariant: BackgroundVariantProps['variant'];
}>();

defineEmits<{
	(e: 'open-profile-menu'): void;
}>();

const handleLogout = () => {
	clear();
};
</script>
